import React, { lazy } from 'react';
import IconANR from '@/assets/images/menu/icon-anr.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import {
  getProductId,
  isAppleTV,
  isMac,
  isVisionOS,
  isAndroid,
  isIOS,
  isWindows,
  isHarmonyOS,
} from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';
const FLUTTER_DROP_FRAME_ISSUE_LIST_PRODUCT_ID = 'afc8f82b01';
const shouldShowANRFrameIssueList = () => isAndroid()
  || isIOS()
  || isMac()
  || isWindows()
  || isVisionOS()
  || isAppleTV()
  || getProductId() === FLUTTER_DROP_FRAME_ISSUE_LIST_PRODUCT_ID;

export const anrRoutes = (): IRouteConfig[] => [
  {
    path: '/exception/anr',
    name: 'ANR',
    icon: <MenuIcon icon={IconANR} fontSize={16} />,
    sort: 98,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.Mac,
      CapitalPlatform.Windows,
      CapitalPlatform.VisionOS,
      CapitalPlatform.AppleTV,
      CapitalPlatform.Flutter,
    ],
    validator: shouldShowANRFrameIssueList,
    routes: [
      {
        path: '/exception/anr/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/anr/analytics')),
        platforms: [CapitalPlatform.IOS, CapitalPlatform.Mac, CapitalPlatform.VisionOS, CapitalPlatform.Windows,
          CapitalPlatform.AppleTV],
      },
      {
        path: '/exception/anr/issues/list',
        name: '问题列表',
        platforms: [CapitalPlatform.IOS, CapitalPlatform.Mac, CapitalPlatform.VisionOS, CapitalPlatform.Windows,
          CapitalPlatform.AppleTV,
        ],
        component: lazy(() => import('@/presentation/pages/anr/issues-ios/list')),
      },
      {
        path: '/exception/anr/issues/detail',
        name: '问题详情',
        platforms: [CapitalPlatform.IOS, CapitalPlatform.Mac, CapitalPlatform.VisionOS, CapitalPlatform.Windows,
          CapitalPlatform.AppleTV,
        ],
        component: lazy(() => import('@/presentation/pages/anr/issues-ios/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/anr/dashboard',
        name: '概览',
        component: lazy(() => import('@/presentation/pages/anr/dashboard')),
        platforms: [CapitalPlatform.Android, CapitalPlatform.HarmonyOS],
      },
      {
        path: '/exception/anr/issues/list',
        name: '问题列表',
        platforms: [CapitalPlatform.Android, CapitalPlatform.HarmonyOS, CapitalPlatform.Flutter],
        component: lazy(() => import('@/presentation/pages/anr/issues-android/list')),
        validator: () => isAndroid()
          || isHarmonyOS()
          || getProductId() === FLUTTER_DROP_FRAME_ISSUE_LIST_PRODUCT_ID,
      },
      {
        platforms: [CapitalPlatform.Android],
        path: '/exception/anr/drop-frame/list',
        name: '关联卡顿列表',
        authName: AuthNodes.WithDropFrame,
        disabledByFree: true,
        component: lazy(() => import('@/presentation/pages/anr/issues-android/drop-frame')),
      },
      {
        path: '/exception/anr/drop-frame/detail',
        name: '关联卡顿详情',
        platforms: [CapitalPlatform.Android, CapitalPlatform.HarmonyOS],
        component: lazy(() => import('@/presentation/pages/anr/issues-android/drop-frame/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/anr/issues/detail',
        name: '问题详情',
        platforms: [CapitalPlatform.Android, CapitalPlatform.HarmonyOS, CapitalPlatform.Flutter],
        component: lazy(() => import('@/presentation/pages/anr/issues-android/detail')),
        hideInMenu: true,
        whitelisted: true,
        validator: () => isAndroid()
          || isHarmonyOS()
          || getProductId() === FLUTTER_DROP_FRAME_ISSUE_LIST_PRODUCT_ID,
      },
      {
        path: '/exception/anr/caller/detail',
        name: '调用方详情',
        platforms: [CapitalPlatform.Android, CapitalPlatform.HarmonyOS],
        component: lazy(() => import('@/presentation/pages/anr/caller-detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
];

export default anrRoutes;
